module.exports = __webpack_public_path__ + "static/media/NotFound.aa259d43.svg";